module.exports = __webpack_public_path__ + "static/media/linkedin.ae251c3d.png";